import { render } from "./RoInput.vue?vue&type=template&id=c58b21f0&scoped=true"
import script from "./RoInput.vue?vue&type=script&lang=js"
export * from "./RoInput.vue?vue&type=script&lang=js"

import "./RoInput.vue?vue&type=style&index=0&id=c58b21f0&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c58b21f0"]])

export default __exports__